import Header from "./components/Header";
import Hero from "./components/Hero";
import HeatRank from "./components/HeatRank";
import WeeklyPicks from "./components/WeeklyPicks";
import CategoryFeed from "./components/CategoryFeed";
import FreshNews from "./components/FreshNews";
import DeepDive from "./components/DeepDive";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqItems } from "@/mocks/gossip";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "每日瓜料",
  url: "https://lldkoos.cn/",
  description: "每日瓜料是专为吃瓜群众打造的娱乐热点聚合站，把一周热门瓜料与近期新瓜集中到一页，按热度排列。",
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: { "@type": "EntryPoint", urlTemplate: "https://lldkoos.cn/search?q={search_term_string}" },
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "每日瓜料",
  url: "https://lldkoos.cn/",
  slogan: "热门瓜 · 一页看全",
  description: "面向娱乐爱好者的中文热门瓜料聚合站，提供今日热榜、一周瓜料汇总、分类翻田与深度专栏。",
};

const collectionSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "每日瓜料 · 一周热门瓜一页看全",
  url: "https://lldkoos.cn/",
  description: "一周热门瓜料与近期新瓜汇总页面，按热度排列今日热榜与本周必吃热门瓜。",
  isPartOf: { "@type": "WebSite", name: "每日瓜料" },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "首页", item: "https://lldkoos.cn/" },
    { "@type": "ListItem", position: 2, name: "一周热门瓜一页看全" },
  ],
};

const schemaBlocks = [websiteSchema, orgSchema, collectionSchema, faqSchema, breadcrumbSchema];

export default function Home() {
  return (
    <>
      {schemaBlocks.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
      <Header />
      <main>
        <Hero />
        <HeatRank />
        <WeeklyPicks />
        <CategoryFeed />
        <FreshNews />
        <DeepDive />
        <FaqSection />
        <AboutSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}